import React, { useState } from "react";
import TimeSpanInputs from "components/fragments/product-template-configurator/ProductTemplateAttributesConfiguration/type-fields/components/TimeSpanInputs";
import { Button } from "primereact/button";
import { DashboardEditorProps } from "components/ComponentTypeTypes";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { T } from "services/lang/LanguageService";
import UniversalDatasetEditorDialog from "./UniversalDatasetEditorDialog";
import { IUniversalDatasetTableConfig } from "../UniversalDatasetTableTypes";

const UniversalDatasetTableEditor = ({
  config,
  onConfigChange,
}: DashboardEditorProps<IUniversalDatasetTableConfig>) => {
  const [isDialogVisible, setDialogVisible] = useState<boolean>(false);

  return (
    <div className="flex flex-column gap-3">
      <div className="flex flex-row gap-3">
        <div className="col-2 gap-2 flex flex-column">
          <Button
            icon="pi pi-list"
            label={T("action.edit-list")}
            className="component-editor-button icon-blue"
            onClick={() => setDialogVisible(true)}
          />
        </div>

        <div className="flex flex-column gap-2">
          <label htmlFor="showColumnHeaders">{T("action.show-column-headers")}</label>
          <InputSwitch
            id="showColumnHeaders"
            checked={config.showColumnHeaders ?? false}
            onChange={e => onConfigChange({ ...config, showColumnHeaders: e.value })}
          />
        </div>
        <div className="flex flex-column gap-2">
          <label htmlFor="compactModee">{T("config.compact-mode")}</label>
          <InputSwitch
            id="compactMode"
            checked={config.compactMode ?? false}
            onChange={e => onConfigChange({ ...config, compactMode: e.value })}
          />
        </div>
      </div>
      <div className="flex flex-row gap-3">
        <div className="col-4 gap-2 flex flex-column">
          <label>{`${T("word.max")} ${T("word.age").toLowerCase()}`}</label>
          <div className="p-inputgroup">
            <TimeSpanInputs
              value={config.maxAge ?? 0}
              onChange={val => onConfigChange({ ...config, maxAge: val })}
            />
          </div>
        </div>
        <div className="col-3 gap-2 flex flex-column">
          <label htmlFor="updateFrequency">{T("load-conf.update-frequency")}</label>
          <div className="p-inputgroup w-full">
            <InputNumber
              id="updateFrequency"
              style={{ blockSize: "2.8rem" }}
              value={config.updateFrequency ?? null}
              onValueChange={e => onConfigChange({ ...config, updateFrequency: e.value })}
            />
            <span className="p-inputgroup-addon">s</span>
          </div>
        </div>
      </div>
      {isDialogVisible && (
        <UniversalDatasetEditorDialog
          config={config}
          onConfigChange={onConfigChange}
          isDialogVisible={isDialogVisible}
          setDialogVisible={setDialogVisible}
        />
      )}
    </div>
  );
};

export default UniversalDatasetTableEditor;
